import { type PlatformType } from '@cart-services/hooks/fp-b2b/store-map'
import { useFpB2bCartService } from '@cart-services/hooks/fp-b2b/use-fp-b2b-cart-service'
import { useEffectOnce } from '@dni-react-hooks/use-effect-once'
import { useHistory, useLocation } from 'react-router-dom-v5'

export const useConditionalRedirectWhenEntry = (campaignId: number, platform: PlatformType, fallbackUrl?: string) => {
  const history = useHistory()
  const location = useLocation()
  const { isCartEmpty } = useFpB2bCartService(campaignId, platform)
  /**
   * 使用 once 避免清空購物車時被轉址
   */
  useEffectOnce(() => {
    /**
     * 如果 fallbackUrl 存在，且 cart 為空則重定向到 fallbackUrl
     */
    const gotoFallbackUrl = () => {
      if (!fallbackUrl) return
      /**
       * 如果 fallbackUrl 和 current path 相同，則不重定向
       */
      if (fallbackUrl === location.pathname) return
      if (isCartEmpty) {
        history.replace(fallbackUrl)
      }
    }
    gotoFallbackUrl()
  })
}
